import './UserAvatar.css';

interface UserAvatarProps {
  size: number;
  photoUrl?: string | null;
}

export default function UserAvatar({ size, photoUrl }: UserAvatarProps) {
  const style = {
    width: size,
    height: size,
    borderRadius: size / 2,
  };

  const displayPhoto = photoUrl || '/images/unmanned.png';

  return (
    <div className="user-avatar-photo">
      <div className="user-avatar" style={style}>
        <img src={displayPhoto} alt="プロフィール写真" />
      </div>
    </div>
  );
}